import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function VisitsByDayAmenityChart() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  let url = "/visit?delete=false";

  let obj = window.location;

  if (typeof obj.hash === "string" && obj.hash.includes("DELETE")) {
    console.log("Hash contains the word DELETE");
    url = "/visit?delete=true";
  } else {
    console.log("Hash does not contain DELETE");
  }

  useEffect(() => {
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(({ data }) => {
        console.log(data);
        // data.rows contains the visit array
        const visits = data.rows;

        // Step 1: Identify all unique amenities
        const amenitiesSet = new Set(
          visits.map((v) => v.amenity.toLowerCase().trim())
        );
        const amenities = Array.from(amenitiesSet);

        // Step 2: Initialize counts[amenity][day] = 0
        // We'll store data as: { [amenity]: [7 days counts] }
        const counts = {};
        amenities.forEach((am) => {
          counts[am] = new Array(7).fill(0);
        });

        // Step 3: Count visits by day of week & amenity
        visits.forEach(({ start_datetime, visitors, amenity }) => {
          const dt = new Date(start_datetime);
          const day = dt.getDay();//dt.getUTCDay(); // 0=Sun..6=Sat
          const amen = amenity.toLowerCase().trim();

          // Add visitors count for that amenity and day
          if (counts[amen]) {
            counts[amen][day] += visitors;
          }
        });

        // Step 4: Prepare datasets for Chart.js
        // Assign a color per amenity (basic palette)
        const palette = [
          "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099",
          "#0099C6", "#DD4477", "#66AA00", "#B82E2E", "#316395",
          "#994499", "#22AA99", "#AAAA11", "#6633CC", "#E67300",
          "#8B0707", "#329262", "#5574A6", "#3B3EAC", "#B77322",
          "#16D620", "#B91383", "#F4359E", "#9C5935", "#A9C413",
          "#2A778D", "#668D1C", "#BEA413", "#0C5922", "#743411"
        ];


        const datasets = amenities.map((am, i) => ({
          label: am,
          data: counts[am],
          backgroundColor: palette[i % palette.length],
          stack: "stack1",
        }));

        setChartData({
          labels: dayLabels,
          datasets,
        });
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading chart data...</p>;
  if (error) return <p>Error loading data: {error}</p>;

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Visits by Day of Week & Amenity",
      },
      legend: {
        display: false,
        position: "right",
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Visitors",
        },
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default VisitsByDayAmenityChart;
